import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b41320e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkConfirm" }
const _hoisted_2 = { class: "OkConfirm__container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Хотите подтвердить действие?", -1))
const _hoisted_4 = { class: "container__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ok_button = _resolveComponent("ok-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ok_button, {
          class: "OkButton--blue",
          onClick: _ctx.onConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Да ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_ok_button, {
          class: "OkButton--blue OkButton--outline",
          onClick: _ctx.onCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Нет ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}